export default {
  methods: {
    openModal() {
      this.$store.commit('modals/SET_GRADING_MODAL', true);
    },
  },

  render() {
    return this.$scopedSlots.default({
      openModal: this.openModal,
    });
  },
};
